import { render } from "./TermsConditionsView.vue?vue&type=template&id=4cf35ec3&scoped=true"
import script from "./TermsConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsConditionsView.vue?vue&type=script&lang=js"

import "./TermsConditionsView.vue?vue&type=style&index=0&id=4cf35ec3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf35ec3"]])

export default __exports__